import React, { useState, useContext } from 'react'
import { Card } from 'react-bootstrap';
import { GetUserContext } from '../Context/GetUserContext';
import CarMarketNull from '../Components/PageOrders/CarMarketNull';
import FinalizeCart from '../Components/PageOrders/FinalizeCart';
import OrdersDetails from '../Components/PageOrders/OrdersDetails';
import CanceledOrders from '../Components/PageOrders/CanceledOrders';
import './PagePedidos.css'

const PagePedidos = () => {
    const [carMarket, setCarMarket] = useState(true)
    const { conjIdHome } = useContext(GetUserContext);

    return (
        <>
            <Card className='card-container'>
                <Card.Body className='card-content-body'>
                    {conjIdHome == 1 && (<OrdersDetails />)}
                </Card.Body>
            </Card>
            <div></div>
        </>
    )
}

export default PagePedidos